// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-3be05d67]{width:100%;text-align:center;border:1px solid #dee2e6;border-collapse:collapse}.table td[data-v-3be05d67],.table th[data-v-3be05d67]{padding:2% 0;border:1px solid #dee2e6}.drawer-footer[data-v-3be05d67]{width:100%;position:absolute;bottom:0;left:0;border-top:1px solid #e8e8e8;padding:10px 16px;text-align:right;background:#fff}", ""]);
// Exports
module.exports = exports;
